import {DraftSortField} from 'src/openapi/admin/models/DraftSortField';

export const SECTION_NAME = 'SSO Self-Service Dashboard';

export const COLUMNS = {
    ACCOUNT_NAME: 'accountName',
    STATUS: 'status',
    CURRENT_STEP: 'currentStep',
    SSO_ENABLED: 'ssoEnabled',
    SSO_MANDATORY: 'ssoMandatory',
    CREATED: 'created',
    FINISHED: 'finished',
    CUSTOMER_ADMIN: 'customerAdmin',
    LAST_UPDATE: 'lastUpdate',
};

export const HEADERS = {
    [COLUMNS.ACCOUNT_NAME]: 'Account Name',
    [COLUMNS.STATUS]: 'Status',
    [COLUMNS.CURRENT_STEP]: 'Current Step',
    [COLUMNS.SSO_ENABLED]: 'SSO Enabled',
    [COLUMNS.SSO_MANDATORY]: 'SSO Mandatory',
    [COLUMNS.CREATED]: 'Created',
    [COLUMNS.FINISHED]: 'Finished',
    [COLUMNS.CUSTOMER_ADMIN]: 'Customer Admin',
    [COLUMNS.LAST_UPDATE]: 'Time since last activity',
};

export const COLUMNS_DATA = [
    {
        columnId: COLUMNS.ACCOUNT_NAME,
        fixed: true,
        defaultWidth: 320,
        minWidth: 260,
        maxWidth: 520,
    },
    {
        columnId: COLUMNS.STATUS,
        fixed: false,
        defaultWidth: 160,
        minWidth: 140,
        maxWidth: 240,
    },
    {
        columnId: COLUMNS.CURRENT_STEP,
        fixed: false,
        defaultWidth: 220,
        minWidth: 180,
        maxWidth: 320,
    },
    {
        columnId: COLUMNS.SSO_ENABLED,
        fixed: false,
        defaultWidth: 150,
        minWidth: 130,
        maxWidth: 200,
    },
    {
        columnId: COLUMNS.SSO_MANDATORY,
        fixed: false,
        defaultWidth: 160,
        minWidth: 140,
        maxWidth: 220,
    },
    {
        columnId: COLUMNS.CREATED,
        fixed: false,
        defaultWidth: 260,
        minWidth: 220,
        maxWidth: 340,
    },
    {
        columnId: COLUMNS.FINISHED,
        fixed: false,
        defaultWidth: 180,
        minWidth: 180,
        maxWidth: 340,
    },
    {
        columnId: COLUMNS.CUSTOMER_ADMIN,
        fixed: false,
        defaultWidth: 260,
        minWidth: 220,
        maxWidth: 340,
    },
    {
        columnId: COLUMNS.LAST_UPDATE,
        fixed: false,
        defaultWidth: 160,
        minWidth: 140,
        maxWidth: 220,
    },
];

export const FILTER_STRIP_LABELS = {
    status: 'Status',
    currentStep: 'Current Step',
    ssoEnabled: 'SSO Enabled',
    ssoMandatory: 'SSO Mandatory',
    hasErrors: 'Error',
    createdFrom: 'Created From',
    createdTo: 'Created To',
    finishedFrom: 'Finished From',
    finishedTo: 'Finished To',
};

export const SORT_FIELDS = {
    [COLUMNS.STATUS]: DraftSortField.STATUS,
    [COLUMNS.CURRENT_STEP]: DraftSortField.CURRENT_STEP,
    [COLUMNS.SSO_ENABLED]: DraftSortField.SSO_ENABLED,
    [COLUMNS.SSO_MANDATORY]: DraftSortField.SSO_MANDATORY,
    [COLUMNS.CREATED]: DraftSortField.CREATED_AT,
    [COLUMNS.FINISHED]: DraftSortField.FINISHED_AT,
};
